import { timeRangeLabel } from '../components/controls/timeRangePresets';
import type { Control, ControlOption, ControlSelections } from '../types/controls';

/** Beyond this, values are counted rather than listed — a caption is not a legend. */
const MAX_LISTED_VALUES = 3;

const labelOf = (value: string, options: ControlOption[]): string =>
  options.find((option) => option.value === value)?.label ?? value;

const describeValues = (values: string[], options: ControlOption[]): string =>
  values.length > MAX_LISTED_VALUES
    ? `${values.length} selected`
    : values.map((value) => labelOf(value, options)).join(', ');

export type ExportCaptionInput = {
  controls: Control[];
  selections: ControlSelections;
  /** Keyed by control key, for turning stored values back into their labels. */
  options: Record<string, ControlOption[]>;
  timeRange: string | undefined;
};

/** `["Deployment: Acme prod", "Platform: RING", "Last 7 days"]` — header order, period last. */
export const exportCaption = ({ controls, selections, options, timeRange }: ExportCaptionInput): string[] => {
  const criteria = controls
    .filter((control) => (selections[control.key]?.length ?? 0) > 0)
    .map((control) => `${control.label}: ${describeValues(selections[control.key], options[control.key] ?? [])}`);

  return timeRange ? [...criteria, timeRangeLabel(timeRange)] : criteria;
};
